import Place from "@wikicasa/common/model/Place";
import {encodeCookie, removeCookie} from "@wikicasa/common/common";
//@ts-ignore
import {Nullable} from "@customTypes/CustomUtilityTypes";


export const saveValuationCookies = (place: Place, typologyID = 1, isSelling = false): void => {
    removeCookie("publicValuationRequestCookie");
    removeCookie("consentCookie");
    const publicValuation = {
        realEstateValuation: {
            latitude: place?.latitude,
            longitude: place?.longitude,
            cityID: place?.cityID,
            sale: true,
            sqM: null,
            rooms: null,
            address: place?.address || "",
            typologyID,
            macroTypologyID: 1,
            isSelling: isSelling
        }
    }
    encodeCookie("publicValuationCookie", publicValuation);
}
export const redirectToValuation = (place: Nullable<Place>, typologyID?: number, isSelling = false): void => {
    if(!place)
        return

    saveValuationCookies(place, typologyID, isSelling);
    location.href = window["_valuationStep2"];
}